'use strict';

var _extends = require('babel-runtime/helpers/extends')['default'];

exports.__esModule = true;
exports['default'] = post;
exports.isLoaded = isLoaded;
exports.load = load;
var POST_LOAD = 'POST_LOAD';
var POST_LOAD_SUCCESS = 'POST_LOAD_SUCCESS';
var POST_LOAD_FAIL = 'POST_LOAD_FAIL';

var initialState = {
  loaded: false
};

function post() {
  var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
  var action = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

  switch (action.type) {
    case POST_LOAD:
      return _extends({}, state, {
        loading: true
      });
    case POST_LOAD_SUCCESS:
      return _extends({}, state, {
        loading: false,
        loaded: true,
        data: action.result,
        id: action.id
      });
    case POST_LOAD_FAIL:
      return _extends({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    default:
      return state;
  }
}

function isLoaded(globalState, postId) {
  return globalState.post && globalState.post.loaded && globalState.post.id === postId;
}

function load(postId) {
  return {
    types: [POST_LOAD, POST_LOAD_SUCCESS, POST_LOAD_FAIL],
    promise: function promise(client) {
      return client.get('wp/posts/?slug=' + postId);
    },
    id: postId
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/post.js
// module id = 181
// module chunks = 0